import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ZipCodes } from 'src/app/features-common/constants/ZipCodes';
import { RetailerService } from '../../retailers/retailer.service';
import { ManageUserService } from '../manage-user.service'; 

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent extends FeaturesBaseComponent implements OnInit {
  @Input() businessnames;
  @Input() salespricelists;
  @Input() userDetail;
  @Input() userId;
  @Input() roles;
  editUserForm: FormGroup;
  phone: (string | RegExp)[];
  usStateZips = ZipCodes.USAStatesShort;
  thresholdAmount = [25, 50, 75, 100, 125, 150, 175, 200, 225, 250];
  //API
  //roles: string[] = ['Sales Rep', 'Admin', 'User', 'Retailer']
  //roles: string[] = ['Admin', 'Sub-Admin', 'Retailer', 'Sales Rep/Distr', 'Billing Dept', 'Customer support'];
  retailers: string[] = ['Henry','Peter', 'Lee', 'Alca','Kim'] 
  status: string[] = ['Active', 'InActive']
  autoReloadStatus: boolean = false;
  accountNumber:string = '10-344323';
  userName: string;
  showSalesrepFields: boolean = false;
  showRetailerFields: boolean = false;
  selectedRole: any;
  emailPattern: RegExp;
  phonePattern: RegExp;
  phoneRegx = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  showIvrCode: boolean = false; 

  constructor(private router: Router, private dialog : MatDialog, private manageUserService: ManageUserService) {
    super();
    this.phone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    this.emailPattern =  /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
    this.phonePattern = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
   
  }
  charMask(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9| ]+$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }
    return nameMask;
  }


  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnChanges(changes: SimpleChanges){
    if (changes['businessnames']){
      this.businessnames = changes['businessnames'].currentValue;
    }
    if (changes['salespricelists']){
      this.salespricelists = changes['salespricelists'].currentValue;
    }
    if (changes['roles']){
      this.roles = changes['roles'].currentValue;
    }
    if (changes['userDetail']) {
      this.userDetail = changes['userDetail'].currentValue;
     
      this.patchEditUserForm(this.userDetail)
      this.editUserForm.updateValueAndValidity();
    }
  }
  patchEditUserForm(userDetail: any) {
      this.initForm();
      this.editUserForm.patchValue({
        'firstName': userDetail?.firstName,
        'lastName': userDetail?.lastName,
        'userName': userDetail?.userName,
        'email': userDetail?.email,
        'mobileNumber': userDetail?.mobileNumber,
        'role': userDetail?.role,
        'status': userDetail?.status,
        'retailerId': userDetail?.retailerId,
        'creditLineAmnt': userDetail?.creditLineAmount,
        'thresholdAmnt': userDetail?.setThresholdAmount,
        'autoReloadStatus': userDetail?.setToAutoReload,
        'pricelist': userDetail?.priceList,
        'address1': userDetail?.address1,
        'city': userDetail?.city,
        'state': userDetail?.state,
        'zip': userDetail?.zipCode,

        'ivrAccess': userDetail?.ivrAccess ? userDetail?.ivrAccess : 'No',
        'ivrCode': userDetail?.ivrCode

      })
    this.userName = this.editUserForm.get('userName').value;
   
    if(this.editUserForm.get('role').value == "Retailer"){
      this.roles = ['Retailer'];
    }else{
      const index = this.roles.indexOf('Retailer');
      if (index > -1) {
        this.roles.splice(index, 1);
      }
    }  
    if(this.editUserForm.get('role').value == "Retailer"){
      this.showRetailerFields = true;
      this.showSalesrepFields = false;

      this.onRoleSelected("Retailer");
    }
    if(this.editUserForm.get('role').value == "Sales Rep"){
      //alert("Hello")
      this.showRetailerFields = false;
      this.showSalesrepFields = true;
      this.onRoleSelected("Sales Rep");
    }
  }

  onIvrStatusChange(e){
    if (e == 'Yes') {
      this.editUserForm.controls['ivrAccess'].setValidators([Validators.required]);
      this.editUserForm.controls['ivrAccess'].updateValueAndValidity()
      this.showIvrCode = true;
    }
    else if(e == 'No'){
      this.editUserForm.controls['ivrCode'].clearValidators()
      this.editUserForm.controls['ivrAccess'].updateValueAndValidity()
      this.showIvrCode = false;

    }
  }

  initForm() {
    this.editUserForm = new FormGroup({
      firstName: new FormControl('',[Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      userName: new FormControl('', [Validators.required]),
      email: new FormControl('',[Validators.required, Validators.pattern(this.emailPattern)]),
      mobileNumber: new FormControl('',[Validators.required, Validators.pattern(this.phoneRegx)]),
      role: new FormControl('', [Validators.required]),
      status: new FormControl('',[Validators.required]),
      retailerId: new FormControl(''),
      ivrAccess: new FormControl(''),
      ivrCode: new FormControl(''),
      creditLineAmnt: new FormControl(''),
      thresholdAmnt: new FormControl('',),
      autoReloadStatus: new FormControl(true),
      pricelist: new FormControl(''),
      address1: new FormControl('',[Validators.required]),
      city: new FormControl('',[Validators.required]),
      state: new FormControl('',[Validators.required]),
      zip: new FormControl('',[Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')]),
    })
  }

  get f() {
    return this.editUserForm.controls;
  }

  editUserSubmit($event) {
    
    if (!this.editUserForm.valid) {
      return
    }
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.setSubmitParameters(this.editUserForm)
        }
      });

  }
  setSubmitParameters(editUserForm: FormGroup) {
    let formData = {
      "address1": editUserForm.get('address1').value,
      "city": editUserForm.get('city').value,
      "creditLineAmount": editUserForm.get('creditLineAmnt').value,
      "email": editUserForm.get('email').value,
      "firstName": editUserForm.get('firstName').value,
      "lastName": editUserForm.get('lastName').value,
      "mobileNumber": editUserForm.get('mobileNumber').value,
      "priceList": editUserForm.get('pricelist').value,
      "role": editUserForm.get('role').value,
      "retailerId": editUserForm.get('retailerId').value,
      "ivrAccess": editUserForm.get('ivrAccess').value,
      "ivrCode": this.showIvrCode ? editUserForm.get('ivrCode').value : null,
      "setThresholdAmount": editUserForm.get('thresholdAmnt').value,
      "setToAutoReload": editUserForm.get('autoReloadStatus').value,
      "state": editUserForm.get('state').value,
      "status": editUserForm.get('status').value,
      "userId": parseInt(this.userId),
      "userName": editUserForm.get('userName').value,
      "zipCode": editUserForm.get('zip').value,
    }
    
    this.manageUserService.updateUser(formData).subscribe(
      res => {
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_111") || res.responseStatus == 'Success'){
          //alert("test");
          this.toastrService.success('User updated successfully!', 'Success', {
            timeOut: 3000,
          })
          //alert("test2");
          this.initForm();
          this.router.navigateByUrl('features/manage-users/all-users')
        }
      }
    )
  }
  onCancel() {
    const dialogRefCancel = this.dialog.open(DialogComponent, {
      data: {
        message: 'pages.placeholders.Areyousureyouwanttocancelthechanges',
        buttonText: {
          ok: 'pages.newRetailer.yes',
          cancel: 'pages.newRetailer.cancel'
        }
      } 
    });

    dialogRefCancel.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.router.navigateByUrl('features/manage-users/all-users')
    return
      }
    });


  }
  checkautoReloadStatus(e) {
    this.autoReloadStatus = e.checked;
    if (this.autoReloadStatus) {
      this.editUserForm.controls['thresholdAmnt'].setValidators([Validators.required])
    }
    else {
      this.editUserForm.controls['thresholdAmnt'].clearValidators();
    }
    this.editUserForm.controls['thresholdAmnt'].updateValueAndValidity();
  }

  
  onRoleSelected(e) {
    this.selectedRole = e;
    if (this.selectedRole == 'Sales Rep') {
      this.showSalesrepFields = true;
      this.showRetailerFields = false;
      this.editUserForm.controls['pricelist'].setValidators([Validators.required])
      this.editUserForm.controls['pricelist'].updateValueAndValidity();
      
      this.editUserForm.controls['creditLineAmnt'].setValidators([Validators.required])
      this.editUserForm.controls['thresholdAmnt'].setValidators([Validators.required])
      this.editUserForm.controls['autoReloadStatus'].setValue(true)
      this.editUserForm.controls['autoReloadStatus'].setValidators([Validators.required])
      this.editUserForm.controls['autoReloadStatus'].updateValueAndValidity();
      this.editUserForm.controls['thresholdAmnt'].updateValueAndValidity();
      this.editUserForm.controls['creditLineAmnt'].updateValueAndValidity();
      this.editUserForm.controls['retailerId'].clearValidators()
      this.editUserForm.controls['retailerId'].updateValueAndValidity();
      this.editUserForm.controls['ivrAccess'].clearValidators()
      this.editUserForm.controls['ivrAccess'].updateValueAndValidity();
      this.editUserForm.controls['ivrCode'].clearValidators()
      this.editUserForm.controls['ivrCode'].updateValueAndValidity();
      return
  }
  if (this.selectedRole == 'Retailer') {
    this.showSalesrepFields = false;
    this.showRetailerFields = true;
    this.editUserForm.controls['retailerId'].setValidators([Validators.required]);
    this.editUserForm.controls['retailerId'].updateValueAndValidity()
    if (this.editUserForm.get('ivrAccess').value == 'Yes'){
      this.editUserForm.controls['ivrCode'].setValidators([Validators.required]);
      this.editUserForm.controls['ivrCode'].updateValueAndValidity()
      this.showIvrCode = true;
    }
    else{
      this.editUserForm.controls['ivrCode'].clearValidators()
      this.editUserForm.controls['ivrAccess'].updateValueAndValidity()
      this.showIvrCode = false;

    }

    
    this.editUserForm.controls['creditLineAmnt'].clearValidators()
    this.editUserForm.controls['thresholdAmnt'].clearValidators()
    this.editUserForm.controls['autoReloadStatus'].setValue(false)
    this.editUserForm.controls['autoReloadStatus'].clearValidators()
    this.editUserForm.controls['pricelist'].clearValidators()
    
    this.editUserForm.controls['autoReloadStatus'].updateValueAndValidity();
    this.editUserForm.controls['thresholdAmnt'].updateValueAndValidity();
    this.editUserForm.controls['creditLineAmnt'].updateValueAndValidity();
    this.editUserForm.controls['pricelist'].updateValueAndValidity();
    return
  }
  this.showSalesrepFields = false;
  this.showRetailerFields = false;
    this.editUserForm.controls['creditLineAmnt'].clearValidators()
    this.editUserForm.controls['thresholdAmnt'].clearValidators()
    this.editUserForm.controls['autoReloadStatus'].setValue(false)
    this.editUserForm.controls['autoReloadStatus'].clearValidators()
    this.editUserForm.controls['pricelist'].clearValidators()
    this.editUserForm.controls['pricelist'].updateValueAndValidity();
    this.editUserForm.controls['autoReloadStatus'].updateValueAndValidity();
    this.editUserForm.controls['thresholdAmnt'].updateValueAndValidity();
    this.editUserForm.controls['creditLineAmnt'].updateValueAndValidity();
    this.editUserForm.controls['retailerId'].clearValidators()
    this.editUserForm.controls['retailerId'].updateValueAndValidity();

    this.editUserForm.controls['ivrAccess'].clearValidators()
    this.editUserForm.controls['ivrAccess'].updateValueAndValidity();
    this.editUserForm.controls['ivrCode'].clearValidators()
    this.editUserForm.controls['ivrCode'].updateValueAndValidity();
    return
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

  checkSubmitDisplayed() {
    return !(this.editUserForm.valid && !this.editUserForm.pristine); 
  }

}
